// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:12:00.821Z
// Property: Swan Creek (ID: 6767906449167127)
// Collections: 30 amenities, 18 floorplans (live), 29 photos, 41 POIs, 4 reviews, 4 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167127",
  "property_external_id": "745543",
  "property_zillow_url": "https://www.zillow.com/apartments/fitchburg-wi/swan-creek/63f4L3/",
  "property_apartments_url": "https://www.apartments.com/swan-creek-fitchburg-wi/4ec5rfk/",
  "property_google_business_url": "https://www.google.com/maps/place/Swan+Creek/data=!4m2!3m1!1s0x0:0x563dff965b31b68d?sa=X&ved=2ahUKEwjWpYnky4OTAxWfH7kGHW2cLNgQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47672016277",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "swan-creek",
  "property_name": "Swan Creek",
  "property_website_url": "https://www.swancreekfitchburg.com",
  "property_domain": "https://www.swancreekfitchburg.com",
  "property_address": "5160 E. Cheryl Parkway",
  "property_full_address": "5160 E. Cheryl Parkway, Fitchburg, WI, 53711",
  "property_address_1": "5160 E. Cheryl Parkway",
  "property_address_2": null,
  "property_address_city": "Fitchburg",
  "property_address_state": "WI",
  "property_address_zip_full": null,
  "property_address_zip": "53711",
  "property_address_country": "US",
  "property_address_county": "Dane",
  "property_neighborhood_address": "Swan Creek",
  "property_address_latitude": "43.0077",
  "property_address_longitude": "-89.3969",
  "property_email": "swancreek@weidner.com",
  "property_phone": "6088892276",
  "property_call_tracking_phone": "608-467-4658",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Swan Creek in Fitchburg, WI, where comfort meets style! Choose from thoughtfully designed floor plans, including studios and spacious two-bedrooms. Enjoy a wealth of amenities like a fitness center, cabana, and scenic courtyard. Elevate your lifestyle—connect with us to tour your future home today!",
  "property_long_description": "**Welcome to Swan Creek – Your Ideal Apartment Community in Fitchburg, WI!**\n\nDiscover a perfect blend of comfort, convenience, and community at Swan Creek. Our thoughtfully designed apartment floor plans include spacious studios, one-bedroom, and two-bedroom options, catering to a variety of lifestyles. Each apartment features modern amenities, from energy-efficient appliances to high-speed internet access, ensuring you enjoy comfort and connectivity.\n\nSwan Creek offers an impressive array of on-site amenities designed to enhance your living experience. Enjoy controlled access for peace of mind, and take advantage of our laundry facilities and on-site maintenance that make everyday living seamless. Whether you're unwinding in our beautiful courtyard or hosting friends at our barbecue grill area or cabana, fun and relaxation are just steps away.\n\nStay active with our fully-equipped fitness center or participate in our planned social activities, perfect for building connections with neighbors. With added conveniences such as additional storage options, a first-come-first-served free parking lot, and elevators for easy access, we prioritize your living comfort.\n\nOur apartments also boast desirable features including walk-in closets, private patios or balconies, and, in select units, unique touches like gas fireplaces and hardwood floors. Enjoy the serenity of our environment with smoke-free living, all while being nestled in the vibrant community of Fitchburg.\n\nDon’t miss your chance to call Swan Creek home! Find your new haven today by browsing our availability or scheduling a tour to experience everything our dynamic community has to offer. Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0216-f69b-7064-a3e2-edeb33147515.webp",
  "property_featured_image_media": {
    "alt_text": "Swan Creek of Nine Springs monument sign and apartment buildings exterior with manicured lawns.",
    "public_id": "019d0216-f69b-7064-a3e2-edeb33147515",
    "storage_key": "property/6767906449167127/019d0216-f69b-7064-a3e2-edeb33147515.webp",
    "width": 2560,
    "height": 936
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "152",
  "property_year_built": "2010",
  "property_year_renovated": null,
  "property_walk_score": "6",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.10526315789474",
  "property_admin_fee": null,
  "property_application_fee": "25",
  "property_fees_deposit_info": "650",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": "350",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "3",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Pets – Max 2 Allowed. Monthly Pet Rent: $40 per pet. Refundable Pet Deposit: $350 per pet. Cats & Dogs are welcome! No weight limit, but breed restrictions apply (e.g., Pit Bull & mixes, American Staffordshire Terrier, Wolf Hybrids, Doberman Pinscher, Saint Bernard, American Bulldog, Staffordshire Bull Terrier, Rottweiler, German Shepherd, Chow Chow, Great Dane, Akita).",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://swancreekfitchburg.securecafe.com/onlineleasing/swan-creek/floorplans.aspx",
  "property_resident_portal_url": "https://swancreekfitchburg.securecafenet.com/residentservices/swan-creek/userlogin",
  "property_apply_now_url": "https://swancreekfitchburg.securecafe.com/onlineleasing/swan-creek/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0217-00f0-7697-8d44-df29fc8771a1.webp",
  "property_primary_logo_media": {
    "alt_text": "Swan Creek Apartment Homes logo",
    "public_id": "019d0217-00f0-7697-8d44-df29fc8771a1",
    "storage_key": "property/6767906449167127/019d0217-00f0-7697-8d44-df29fc8771a1.webp",
    "width": 217,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0217-0e18-747e-820b-8a780f523ecd.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Swan Creek Apartment Homes logo",
    "public_id": "019d0217-0e18-747e-820b-8a780f523ecd",
    "storage_key": "property/6767906449167127/019d0217-0e18-747e-820b-8a780f523ecd.webp",
    "width": 217,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0217-1836-72cd-843d-ff43274c3d1a.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Swan Creek Apartment Homes logo.",
    "public_id": "019d0217-1836-72cd-843d-ff43274c3d1a",
    "storage_key": "property/6767906449167127/019d0217-1836-72cd-843d-ff43274c3d1a.webp",
    "width": 217,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#e55146",
  "property_secondary_color": "#f4ebd8",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "536 - 1274",
  "property_sqft_min": "536",
  "property_sqft_max": "1274",
  "property_price_range": "1285 - 3120",
  "property_price_min": "1285",
  "property_price_max": "3120",
  "property_available_units": 31,
  "property_facebook_url": "https://www.facebook.com/swancreekapartments/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJr3OW-GjMW0ARjbYxW5b_PVY",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Swan Creek",
  "property_home_romance_title": "Embrace Comfort and Community in Your Dream Apartment Home",
  "property_home_amenities_blurb": "Welcome to Swan Creek in Fitchburg, WI, where modern living meets comfort. Choose from stylish studio, one, or two-bedroom homes equipped with upscale amenities like energy-efficient appliances, serene courtyards, and a fitness center. Enjoy planned social activities and a vibrant community atmosphere, all within a secure, gated environment.",
  "property_home_floorplans_blurb": "At Swan Creek in Fitchburg, WI, experience the perfect blend of comfort and style in our thoughtfully designed apartment homes. With a range of unique floor plans to suit every lifestyle, you’re just a step away from your ideal living space. Browse available options today and elevate your lifestyle!",
  "property_home_gallery_blurb": "Welcome to Swan Creek, where vibrant living meets tranquility in Fitchburg, WI. Choose from thoughtfully designed studio, one, and two-bedroom apartments with modern amenities. Enjoy controlled access, a fitness center, and planned social activities while relaxing in our inviting courtyard. Picture yourself living here—your new home awaits!",
  "property_home_neighborhood_blurb": "Welcome to Swan Creek in Fitchburg, WI, where modern living meets educational excellence. With cozy studio, one-bedroom, and two-bedroom floor plans, our community is perfectly located near top-notch schools like Leopold Elementary and West High. Experience comfort and convenience while being steps away from local treasures. Come see what's around!",
  "property_home_reviews_blurb": "At Swan Creek in Fitchburg, WI, residents love the “peaceful atmosphere and friendly neighbors.” Our vibrant community offers spacious living and modern amenities, making it a sanctuary to call home. Dive into our resident reviews and see how Swan Creek elevates everyday living in Wisconsin!",
  "property_neighborhood_blurb": "At Swan Creek in Fitchburg, WI, vibrant schooling options surround you, from Leopold Elementary to Edgewood High School of the Sacred Heart. Immerse yourself in a community enriched by education and play. See what's around our community and discover beloved local attractions and educational hubs that foster growth and connection.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Swan Creek in Fitchburg, WI, where comfort meets convenience. Enjoy an array of amenities, from a state-of-the-art fitness center to serene courtyard views. Choose from studio to two-bedroom floor plans, each designed for modern living. Elevate your lifestyle with features like walk-in closets and energy-efficient appliances.",
  "property_applynow_blurb": "At Swan Creek in Fitchburg, WI, your ideal home awaits. Choose from studio, one, or two-bedroom floor plans, each featuring modern amenities like a fitness center, controlled access, and serene courtyard views. Enjoy vibrant social activities, on-site management, and eco-friendly living. Secure your spot—lease online today!",
  "property_contactus_blurb": "At Swan Creek in Fitchburg, WI, our thoughtfully designed floor plans cater to every lifestyle. Choose from cozy studios to spacious two-bedroom apartments, each crafted with comfort in mind. Curious about your future home? Reach out to our leasing team today for personalized assistance and inquiries!",
  "property_faqs_blurb": "At Swan Creek in Fitchburg, WI, we offer a variety of stylish living spaces, including cozy studios and spacious one- and two-bedroom apartments. Have questions? Our FAQs page tackles everything you need to know about our vibrant community and floor plans. Dive in for clarity and peace of mind!",
  "property_floorplans_blurb": "At Swan Creek in Fitchburg, WI, choose from a variety of distinctive floor plans that elevate your living experience. Whether you crave the cozy charm of a studio, the spacious comfort of a one-bedroom, or the versatility of a two-bedroom, we have the ideal space for you. Browse our available apartment homes today!",
  "property_gallery_blurb": "At Swan Creek in Fitchburg, WI, vibrant living meets serene comfort. Immerse yourself in a lifestyle enriched with modern conveniences like a fitness center, elegant courtyards, and social activities. Imagine cozy evenings by the fireplace in select units or grilling in the cabana. Picture yourself living here!",
  "property_interactivemap_blurb": "At Swan Creek in Fitchburg, WI, find your perfect fit among our stylish studio, one, and two-bedroom apartments. Enjoy a vibrant community with inviting amenities like controlled access, a fitness center, and planned social activities. Use our interactive map to uncover your future home today!",
  "property_pets_blurb": "At Swan Creek in Fitchburg, WI, your furry companions are part of the family! With no weight limit and a welcoming atmosphere, our community invites you to share your home with up to two pets. Enjoy amenities designed for both comfort and playful adventures in a serene setting.",
  "property_referafriend_blurb": "At Swan Creek in Fitchburg, WI, we believe great friends make great neighbors! Our diverse floor plans—cozy studios, spacious one-bedroom, and inviting two-bedroom apartments—cater to your lifestyle. Share your comfort and joy: refer a friend today and create lasting memories in our vibrant community!",
  "property_residentaccess_blurb": "Welcome to Swan Creek in Fitchburg, WI, where comfort meets convenience. Our diverse floor plans, including studio, one-bedroom, and two-bedroom options, cater to every lifestyle. Log in to your resident portal for easy rent payments, maintenance requests, and more—making your living experience seamless and stress-free.",
  "property_reviews_blurb": "At Swan Creek in Fitchburg, WI, residents rave about their experience, with one saying, \"The sense of community here is unparalleled.\" Join a vibrant lifestyle where comfort and connection flourish. See what our residents have to say about living at our community, and envision your new home today!",
  "property_created_at": "1771528849962",
  "property_scheduletour_blurb": "At Swan Creek in Fitchburg, WI, your ideal living space awaits, whether it's a cozy studio or a spacious two-bedroom. Each thoughtfully designed floor plan blends comfort and style. Ready to experience our vibrant community? Schedule a tour and hear directly from our residents about their enchanting lifestyle!",
  "property_thankyou_blurb": "Thank you for reaching out to Swan Creek in Fitchburg, WI! Whether you’re drawn to our cozy studios or spacious two-bedroom layouts, your perfect home awaits. Our team will connect with you shortly to guide you through our diverse floor plans and help you take the next step.",
  "property_virtualtours_blurb": "At Swan Creek in Fitchburg, WI, our thoughtfully designed studio, one-bedroom, and two-bedroom apartments offer the perfect blend of comfort and style. Experience the inviting ambiance through our virtual tour and envision your new home surrounded by vibrant community amenities. Click to start your journey today!",
  "property_copyright": "2026 All Rights Reserved. Swan Creek",
  "property_seo_title_home": "Swan Creek |  Apartments in Fitchburg, WI",
  "property_seo_description_home": "Experience modern living at Swan Creek in Fitchburg, WI. Enjoy stylish floor plans, exceptional amenities, and a vibrant community. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Fitchburg, WI Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Swan Creek in Fitchburg, WI. Choose from stylish studios to spacious two-bedrooms. Browse our floor plans and envision your new home!",
  "property_seo_title_amenities": "Amenities | Fitchburg, WI Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at Swan Creek in Fitchburg! Enjoy spacious layouts, a fitness center, courtyard, and vibrant community events. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Fitchburg, WI",
  "property_seo_description_gallery": "Discover Swan Creek in Fitchburg, WI! Stylish floor plans and top-notch amenities await. Imagine your perfect lifestyle here!",
  "property_seo_title_virtualtours": "Virtual Tours | Swan Creek Apartments",
  "property_seo_description_virtualtours": "Step inside Swan Creek's inviting studios and spacious one- and two-bedroom apartments in Fitchburg, WI. Take a virtual tour and envision your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Swan Creek Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Swan Creek in Fitchburg, WI! Use our interactive map to explore spacious floor plans, amenities, and more. Your future awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Fitchburg, WI",
  "property_seo_description_neighborhood": "Explore Fitchburg, WI, at Swan Creek. Discover local favorites and attractions just minutes from your new studio, one, or two-bedroom apartment!",
  "property_seo_title_contact": "Contact Us | Swan Creek",
  "property_seo_description_contact": "Elevate your lifestyle at Swan Creek in Fitchburg, WI. From studios to spacious two-bedrooms, our leasing team is ready to assist with your inquiries!",
  "property_seo_title_faqs": "FAQs | Apartments in Fitchburg, WI",
  "property_seo_description_faqs": "Get answers about Swan Creek, Fitchburg, WI! Our FAQs cover amenities and floor plans for a seamless living experience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Fitchburg, WI",
  "property_seo_description_reviews": "Join the Swan Creek community in Fitchburg, WI! Explore resident reviews and enjoy a lifestyle filled with amenities and comfort. Your ideal home awaits!",
  "property_seo_title_applynow": "Apply Now | Apartments in Fitchburg, WI",
  "property_seo_description_applynow": "Discover elegant living at Swan Creek, Fitchburg, WI. Enjoy diverse floor plans, fitness center, and gated access—your perfect home awaits!",
  "property_seo_title_residentaccess": "Resident Access | Swan Creek",
  "property_seo_description_residentaccess": "Enjoy convenience at Swan Creek, Fitchburg! Access your resident portal for rent payments, maintenance requests, and community updates easily.",
  "property_seo_title_referafriend": "Refer A Friend | Swan Creek",
  "property_seo_description_referafriend": "Refer a friend to Swan Creek in Fitchburg, WI! Share the joy of great living and enjoy life’s best moments together in our welcoming community.",
  "property_seo_title_scheduletour": "Schedule a Tour | Swan Creek",
  "property_seo_description_scheduletour": "Experience life at Swan Creek in Fitchburg! Enjoy modern living with stunning amenities. Schedule your personal tour today and discover your new home!",
  "property_seo_title_privacy": "Privacy Policy | Swan Creek",
  "property_seo_description_privacy": "At Swan Creek, Fitchburg, WI, your privacy matters. Read our policy to see how we protect your information while you enjoy community living.",
  "property_seo_title_accessibility": "Website Accessibility | Swan Creek",
  "property_seo_description_accessibility": "At Swan Creek in Fitchburg, WI, we prioritize accessibility for all. Join our community where everyone feels at home—your comfort is our mission!",
  "property_seo_title_sitemap": "Sitemap | Swan Creek",
  "property_seo_description_sitemap": "Uncover every corner of Swan Creek in Fitchburg, WI. Check out our sitemap to navigate your future home and discover the amenities that await you!",
  "property_seo_title_thankyou": "Thank You | Swan Creek",
  "property_seo_description_thankyou": "Thank you for reaching out to Swan Creek in Fitchburg, WI! Our team is excited to assist you in finding your perfect home. Stay tuned for our response!",
  "property_seo_title_pets": "Pet Policy | Apartments in Fitchburg, WI",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293653364",
  "amenities": [
    {
      "id": "custom_d9dd0f64-79aa-40cf-8c5a-d58b6d0e1a8b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1871cf7e-0ec8-4f1a-9233-065b24108624",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c05844d9-984d-4272-9067-3bc194a8ae5c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Cabana/ Gazebo",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_30e3fdd8-68fb-48f6-bd6a-6bbd34f51572",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a87e4068-0e87-43b8-b7ca-82ae301de423",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_98f45d50-7a5b-4e66-b86d-488ebe572f00",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d8faa49-ba99-4d44-bdf3-285ea2d645fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Recycling",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1328f79b-ad6f-4817-ac4c-f6dffc4a79e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_13da92f7-71f3-44e4-9d6b-99381b801ba1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_78e0e813-5d32-4be4-b458-b5a1ee117ea1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b5ca8b68-be17-440b-94bb-cc98b7621f91",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Additional storage",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ac890695-9719-414e-9722-0628ce9e00e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "First Come First Served Free Lot Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ef787a7-4ef1-4261-872c-8ff3c99376ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Rentable Underground Covered Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0725d136-9f18-420d-9de0-b50bf66b07e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Smoke Free",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3999b127-d6ce-4ed7-be2a-cee63b50c934",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e95581c-c6ab-40d7-a8e3-e9ff7b093842",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8e8e02e5-ac98-4c80-9878-ff19bbc4f555",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1b6bd66e-9e52-4ba2-9048-69f9c3a0a03e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d2aadfd2-a496-4f01-9340-8eac84f9c8e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Full Size Washer and Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d9e9c5cc-b86b-4dee-9644-9cbaf915f8d3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Dining Room*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4cd575d5-a343-4401-9c6c-661a57681905",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Linen Closet*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cf09f0e4-b053-4008-9777-a3dd396e5e5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑In Closets*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9f3e0b78-2f5a-432d-8226-c9163cf46df4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a22972a4-fd73-4792-97d0-9044e1560e06",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d92d5eac-9d51-4775-bbbe-816d6266db3a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Ice Maker*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb3f4052-6c45-4ecc-9d48-721c840f9c91",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b4e9a4c9-ecd4-4032-95c1-26d10872eb15",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Pantry*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_308989be-8bf9-4b44-8dd3-4cde64914bf3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Views",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b7b5d418-eb4d-4d23-8c27-e74336db429a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Intercom/Call Box",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f7f74822-1685-4777-a5dc-2e97cfd02d52",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "external_id": "false",
      "title": "Gas Fireplace*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_779d8bbf-678f-4735-ace1-682b4d854d0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-201a-7687-8397-564673a6e913.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with dining table and bar stools.",
        "public_id": "019d0214-201a-7687-8397-564673a6e913",
        "storage_key": "property/6767906449167127/019d0214-201a-7687-8397-564673a6e913.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "Spacious living room with a sofa and accent chair, open to a dining area and kitchen with a breakfast bar.",
      "link": "",
      "alt_text": "Living room and kitchen area with dining table and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (1).jpg"
    },
    {
      "id": "custom_4ab23cb0-394f-4b6d-88fd-b450efddf903",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-201a-7687-8397-516ca505fd83.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with a glass-top table and chairs, a sofa, and a teal accent chair.",
        "public_id": "019d0214-201a-7687-8397-516ca505fd83",
        "storage_key": "property/6767906449167127/019d0214-201a-7687-8397-516ca505fd83.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this stylish apartment, featuring a separate dining area and a spacious living room perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living and dining area with a glass-top table and chairs, a sofa, and a teal accent chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (2).jpg"
    },
    {
      "id": "custom_52f47fbd-6691-4869-900f-649eb8c8dc18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-1c97-75ea-aa3b-0f3acb4af7f6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, black appliances, and granite countertops.",
        "public_id": "019d0214-1c97-75ea-aa3b-0f3acb4af7f6",
        "storage_key": "property/6767906449167127/019d0214-1c97-75ea-aa3b-0f3acb4af7f6.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring light wood cabinetry, sleek black appliances, and durable granite countertops. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with light wood cabinets, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (3).jpg"
    },
    {
      "id": "custom_d46e1c20-ad7d-4f80-8943-187e5370cf1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-2019-73fe-9423-3f88ebcc7e84.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, black refrigerator, black stove, and double sink.",
        "public_id": "019d0214-2019-73fe-9423-3f88ebcc7e84",
        "storage_key": "property/6767906449167127/019d0214-2019-73fe-9423-3f88ebcc7e84.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "A well-lit kitchen featuring light wood cabinetry, a black refrigerator, a black stove with a microwave above it, and a granite-look countertop with a double sink.",
      "link": "",
      "alt_text": "Kitchen with light wood cabinets, black refrigerator, black stove, and double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (4).jpg"
    },
    {
      "id": "custom_a93068f0-0878-4d23-912c-f1a66a769f79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-2a4c-73b0-9cb1-de44fc721f4e.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, black appliances, and granite countertops, opening to a living area with blue armchair.",
        "public_id": "019d0214-2a4c-73b0-9cb1-de44fc721f4e",
        "storage_key": "property/6767906449167127/019d0214-2a4c-73b0-9cb1-de44fc721f4e.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring light wood cabinetry, black appliances including a microwave and dishwasher, and granite countertops. The space flows into a comfortable living area with a blue armchair and coffee table.",
      "link": "",
      "alt_text": "Kitchen with light wood cabinets, black appliances, and granite countertops, opening to a living area with blue armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (5).jpg"
    },
    {
      "id": "custom_6117780b-6e94-4dcb-a740-235a611e2d03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-2acd-724e-b651-a47e8deb340d.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, black microwave, and black stove.",
        "public_id": "019d0214-2acd-724e-b651-a47e8deb340d",
        "storage_key": "property/6767906449167127/019d0214-2acd-724e-b651-a47e8deb340d.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "A well-equipped kitchen featuring modern appliances, ample cabinet space, and stylish granite countertops.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, granite countertops, black microwave, and black stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (6).jpg"
    },
    {
      "id": "custom_71f4cf92-3b9d-4230-a9bb-b428ee4b3a23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-2bc8-717f-8bb3-9446e3bdd4d6.webp",
      "image_media": {
        "alt_text": "Living room and dining area with sofa, armchair, coffee table, dining table, and bar stools.",
        "public_id": "019d0214-2bc8-717f-8bb3-9446e3bdd4d6",
        "storage_key": "property/6767906449167127/019d0214-2bc8-717f-8bb3-9446e3bdd4d6.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sofa, a vibrant armchair, a coffee table, and a dining set with bar stools. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Living room and dining area with sofa, armchair, coffee table, dining table, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (7).jpg"
    },
    {
      "id": "custom_5cb09a0c-0366-4bf1-b684-40748e687cc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-34e9-7499-a4a7-1fe908573167.webp",
      "image_media": {
        "alt_text": "Laundry closet with washer and dryer.",
        "public_id": "019d0214-34e9-7499-a4a7-1fe908573167",
        "storage_key": "property/6767906449167127/019d0214-34e9-7499-a4a7-1fe908573167.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "In-unit laundry closet with stacked washer and dryer, and shelving for storage.",
      "link": "",
      "alt_text": "Laundry closet with washer and dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (9).jpg"
    },
    {
      "id": "custom_f5f1f4b9-2871-4c31-8e6a-7a4872464a65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-3658-704a-bb62-a78ba47ac35b.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and natural light.",
        "public_id": "019d0214-3658-704a-bb62-a78ba47ac35b",
        "storage_key": "property/6767906449167127/019d0214-3658-704a-bb62-a78ba47ac35b.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush king-size bed, elegant ceiling fan, and ample natural light, creating a serene retreat.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and natural light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (10).jpg"
    },
    {
      "id": "custom_8d12d687-545d-49ea-8a90-c0ac7f41e558",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-37a6-717b-87a4-6693a54cadfe.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, mirror, and bed.",
        "public_id": "019d0214-37a6-717b-87a4-6693a54cadfe",
        "storage_key": "property/6767906449167127/019d0214-37a6-717b-87a4-6693a54cadfe.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a dresser with a mirror, a comfortable bed, and a ceiling fan.",
      "link": "",
      "alt_text": "Bedroom with a dresser, mirror, and bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (11).jpg"
    },
    {
      "id": "custom_9b4612c2-5d44-41bb-96cd-57ca79085ca2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-4003-70ff-a6ec-3955184bcd1c.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with a window and hanging rod.",
        "public_id": "019d0214-4003-70ff-a6ec-3955184bcd1c",
        "storage_key": "property/6767906449167127/019d0214-4003-70ff-a6ec-3955184bcd1c.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring a large window and ample shelving, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with a window and hanging rod.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (12).jpg"
    },
    {
      "id": "custom_e2b0d336-ef02-42b9-9fb8-92dd1d791421",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-3f49-778c-958e-1a6d73a49547.webp",
      "image_media": {
        "alt_text": "Bathroom with tub, toilet, vanity with sink and mirror.",
        "public_id": "019d0214-3f49-778c-958e-1a6d73a49547",
        "storage_key": "property/6767906449167127/019d0214-3f49-778c-958e-1a6d73a49547.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a bathtub, toilet, vanity with sink, and a large mirror.",
      "link": "",
      "alt_text": "Bathroom with tub, toilet, vanity with sink and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (13).jpg"
    },
    {
      "id": "custom_3570565a-4f58-4f9b-bf7b-4e28d33d7eb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0216-a578-700a-8add-c2654dcd7091.webp",
      "image_media": {
        "alt_text": "Leasing office reception desk with computer and flowers.",
        "public_id": "019d0216-a578-700a-8add-c2654dcd7091",
        "storage_key": "property/6767906449167127/019d0216-a578-700a-8add-c2654dcd7091.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Community",
      "description": "Welcome to our leasing office! Our friendly staff is ready to assist you with any questions about our community.",
      "link": "",
      "alt_text": "Leasing office reception desk with computer and flowers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (24).jpg"
    },
    {
      "id": "custom_f0efed3b-38f1-492f-88cb-694b3a78d60f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-4a10-72ba-bcce-655002e17d57.webp",
      "image_media": {
        "alt_text": "Gazebo and manicured lawn in a multifamily community.",
        "public_id": "019d0214-4a10-72ba-bcce-655002e17d57",
        "storage_key": "property/6767906449167127/019d0214-4a10-72ba-bcce-655002e17d57.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Community",
      "description": "Enjoy the beautiful outdoor spaces with a charming gazebo and lush green lawns at this multifamily property.",
      "link": "",
      "alt_text": "Gazebo and manicured lawn in a multifamily community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (25).jpg"
    },
    {
      "id": "custom_fe6192c9-38a8-4f15-b44c-885c30b93e47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0216-ae02-734b-82c9-3c28bb46b529.webp",
      "image_media": {
        "alt_text": "Gazebo with tables and chairs, BBQ grill nearby, surrounded by landscaping.",
        "public_id": "019d0216-ae02-734b-82c9-3c28bb46b529",
        "storage_key": "property/6767906449167127/019d0216-ae02-734b-82c9-3c28bb46b529.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings in the charming gazebo, complete with seating and a convenient BBQ grill. Perfect for al fresco dining and relaxing.",
      "link": "",
      "alt_text": "Gazebo with tables and chairs, BBQ grill nearby, surrounded by landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (26).jpg"
    },
    {
      "id": "custom_9ff8c226-89e3-4015-8f1d-c49821f9a005",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-4fcb-75de-9d56-b4d66bbc9aab.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with balconies and green courtyard.",
        "public_id": "019d0214-4fcb-75de-9d56-b4d66bbc9aab",
        "storage_key": "property/6767906449167127/019d0214-4fcb-75de-9d56-b4d66bbc9aab.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Community",
      "description": "Discover comfortable living in this beautifully designed apartment building, featuring private balconies and a lush, welcoming courtyard.",
      "link": "",
      "alt_text": "Exterior view of apartment building with balconies and green courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (27).jpg"
    },
    {
      "id": "custom_11c93084-bcd0-41e6-8246-6085f5b82772",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-5447-716f-8cdf-2cbfa8b3ea20.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved road and parking lot in the foreground.",
        "public_id": "019d0214-5447-716f-8cdf-2cbfa8b3ea20",
        "storage_key": "property/6767906449167127/019d0214-5447-716f-8cdf-2cbfa8b3ea20.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Community",
      "description": "View of the apartment complex exterior on a sunny day, showcasing the buildings and surrounding landscape.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a paved road and parking lot in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (28).jpg"
    },
    {
      "id": "custom_5456e8bd-c03f-47dc-8ef0-7c778d874449",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0216-b82d-77fd-a16c-98eed9a5519f.webp",
      "image_media": {
        "alt_text": "Swan Creek apartment building entrance with pathway and trees.",
        "public_id": "019d0216-b82d-77fd-a16c-98eed9a5519f",
        "storage_key": "property/6767906449167127/019d0216-b82d-77fd-a16c-98eed9a5519f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Swan Creek apartments, offering a beautiful exterior with lush landscaping and a clear pathway to the entrance.",
      "link": "",
      "alt_text": "Swan Creek apartment building entrance with pathway and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (29).jpg"
    },
    {
      "id": "custom_e45bed5f-d301-47cc-8765-2de2575c07d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-59ff-75cf-bd09-a80ca37a67f7.webp",
      "image_media": {
        "alt_text": "Swan Creek of Nine Springs monument sign and apartment building exterior.",
        "public_id": "019d0214-59ff-75cf-bd09-a80ca37a67f7",
        "storage_key": "property/6767906449167127/019d0214-59ff-75cf-bd09-a80ca37a67f7.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Community",
      "description": "Welcome to Swan Creek of Nine Springs, featuring beautiful landscaping and modern apartment building exteriors.",
      "link": "",
      "alt_text": "Swan Creek of Nine Springs monument sign and apartment building exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (30).jpg"
    },
    {
      "id": "custom_ec06416e-d916-4c62-b04e-d3de35bad2f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-42d7-7058-85b6-564dbb1e7740.webp",
      "image_media": {
        "alt_text": "Treadmills and exercise bikes in a fitness center.",
        "public_id": "019d0214-42d7-7058-85b6-564dbb1e7740",
        "storage_key": "property/6767906449167127/019d0214-42d7-7058-85b6-564dbb1e7740.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines and free weights for your workout needs.",
      "link": "",
      "alt_text": "Treadmills and exercise bikes in a fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (14).jpg"
    },
    {
      "id": "custom_51ac7e4a-8097-46b7-9738-ee7cdf0206d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019f00e9-d705-7244-8d2e-763067a6a85a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wooden cabinets, black appliances, and granite countertops.",
        "public_id": "019f00e9-d705-7244-8d2e-763067a6a85a",
        "storage_key": "property/6767906449167127/019f00e9-d705-7244-8d2e-763067a6a85a.webp",
        "width": 1672,
        "height": 941
      },
      "title": "Apartment",
      "description": "This apartment kitchen features ample cabinet space, a full suite of black appliances including a microwave, stove, refrigerator, and dishwasher, all complemented by warm wooden cabinets and durable granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with wooden cabinets, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3d6818f2-857e-4654-ba02-4bb8e1fa5631",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019f00e9-d745-73c0-b83f-d1d4f493d09f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, black appliances, and granite countertops.",
        "public_id": "019f00e9-d745-73c0-b83f-d1d4f493d09f",
        "storage_key": "property/6767906449167127/019f00e9-d745-73c0-b83f-d1d4f493d09f.webp",
        "width": 1672,
        "height": 941
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this stylish kitchen, featuring ample cabinet space, sleek black appliances, and beautiful granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with wood cabinets, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c23a444e-f70d-41d1-a66d-3bb43c996beb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019f002c-32ac-76c7-9e8c-5d3aa70b5454.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and balcony access.",
        "public_id": "019f002c-32ac-76c7-9e8c-5d3aa70b5454",
        "storage_key": "property/6767906449167127/019f002c-32ac-76c7-9e8c-5d3aa70b5454.webp",
        "width": 1672,
        "height": 941
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable sectional sofa, a natural wood coffee table, and a sliding glass door leading to a private balcony. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, coffee table, and balcony access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5f912c6c-ba83-434e-9fbb-282f135c679e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019f002e-a8bf-7420-b376-53b4324dc040.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs, overlooking a hallway with multiple doors.",
        "public_id": "019f002e-a8bf-7420-b376-53b4324dc040",
        "storage_key": "property/6767906449167127/019f002e-a8bf-7420-b376-53b4324dc040.webp",
        "width": 1672,
        "height": 941
      },
      "title": "Apartment",
      "description": "A cozy dining area featuring a round table and chairs, adjacent to a hallway with access to other rooms within the apartment.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs, overlooking a hallway with multiple doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_af93be98-2cc8-46cf-a4f7-376329ad6bba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019f002f-3945-75f2-9bed-170bcb4d0d40.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, white linens, and a ceiling fan.",
        "public_id": "019f002f-3945-75f2-9bed-170bcb4d0d40",
        "storage_key": "property/6767906449167127/019f002f-3945-75f2-9bed-170bcb4d0d40.webp",
        "width": 1672,
        "height": 941
      },
      "title": "Apartment",
      "description": "Relax in the comfortable bedroom featuring a plush queen-size bed with crisp white linens and a soothing ceiling fan. This inviting space offers a tranquil retreat.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, white linens, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10d5e4ef-121b-4de2-b653-c93fce20d7a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019f002f-960c-754f-b83c-e2f36987ee6e.webp",
      "image_media": {
        "alt_text": "A clean, minimalist home office with a wooden desk, laptop, chair, and a framed landscape painting.",
        "public_id": "019f002f-960c-754f-b83c-e2f36987ee6e",
        "storage_key": "property/6767906449167127/019f002f-960c-754f-b83c-e2f36987ee6e.webp",
        "width": 1672,
        "height": 941
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this dedicated home office nook, perfect for productivity and focus.",
      "link": "",
      "alt_text": "A clean, minimalist home office with a wooden desk, laptop, chair, and a framed landscape painting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1691326d-d4fc-49c7-a91a-8edb6a8c0bc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019f002f-bb53-73d8-9a51-f24ed630f064.webp",
      "image_media": {
        "alt_text": "A bathroom with a toilet, shower curtain, and towels.",
        "public_id": "019f002f-bb53-73d8-9a51-f24ed630f064",
        "storage_key": "property/6767906449167127/019f002f-bb53-73d8-9a51-f24ed630f064.webp",
        "width": 1672,
        "height": 941
      },
      "title": "Apartment",
      "description": "A clean and functional apartment bathroom featuring a toilet, bathtub with a decorative shower curtain, and ample towel storage.",
      "link": "",
      "alt_text": "A bathroom with a toilet, shower curtain, and towels.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b206ec95-f369-461c-b738-8acbfc1f11cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019f0030-191d-72b8-b9a2-55cf1767e149.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and lighting.",
        "public_id": "019f0030-191d-72b8-b9a2-55cf1767e149",
        "storage_key": "property/6767906449167127/019f0030-191d-72b8-b9a2-55cf1767e149.webp",
        "width": 1672,
        "height": 941
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom vanity featuring a spacious countertop, a single sink, and a large mirror with overhead lighting. This bathroom offers ample storage and a tidy space.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29dbbd1f-c44d-4ecc-8ebf-82077ffcf102",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0214-32f0-704d-89a1-e46310797572.webp",
      "image_media": {
        "alt_text": "Interior hallway with a linen closet, laundry room, and bathroom.",
        "public_id": "019d0214-32f0-704d-89a1-e46310797572",
        "storage_key": "property/6767906449167127/019d0214-32f0-704d-89a1-e46310797572.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious hallway featuring a convenient linen closet, a dedicated laundry room with washer and dryer, and access to a bathroom.",
      "link": "",
      "alt_text": "Interior hallway with a linen closet, laundry room, and bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WI_Swan_Creek_Favorites (8).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2ebedf58-30e8-4e96-848d-bd6f5fccec0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "579 State St, Madison, WI 53703, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves great chicken tenders, fries, and Texas toast. They also highlight the quick service, clean environment, and fun atmosphere.\n\nSome reviews mention the food can be soggy.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.raisingcanes.com/wi/madison/579-state-street",
      "poi_directions_map_url": "https://maps.google.com/?cid=11501229084781929622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "43.0747492",
      "poi_longitude": "-89.395242",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 608-285-5765",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-89df-736f-a79b-7d1ccf281a93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-89df-736f-a79b-7d1ccf281a93",
        "storage_key": "property/6767906449167127/019d0215-89df-736f-a79b-7d1ccf281a93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ2BfH89TBogRlmTRnuqSnJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_c7a8f2aa-8b3b-4527-b574-0a0b62d3d6df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "The Old Fashioned",
      "poi_type": "Restaurants",
      "poi_address": "23 N Pinckney St #1, Madison, WI 53703, USA",
      "poi_short_description": "Wisconsin-themed, retro-style tavern offering beers, brats & cheese curds (all sourced in-state).",
      "poi_long_description": "People say this restaurant serves delicious cheese curds, burgers, and brats, and offers a wide selection of beers and old fashioneds. They highlight the generous portions, reasonable prices, and unique, Wisconsin-themed atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.theoldfashioned.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1775569272534250276&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-old-fashioned",
      "poi_latitude": "43.0762535",
      "poi_longitude": "-89.38370069999999",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 608-310-4545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-89df-736f-a79b-7d1ccf281a93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-89df-736f-a79b-7d1ccf281a93",
        "storage_key": "property/6767906449167127/019d0215-89df-736f-a79b-7d1ccf281a93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHxgqqEBTBogRJLOAk9gWpBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_083782fe-698a-4abe-976c-9a8e63a6caf7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "2102 W Beltline Hwy, Madison, WI 53713, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "People say this restaurant serves delicious burgers, fries, and fish meals. They also highlight the beautiful outdoor patio seating and the friendly, enthusiastic staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.culvers.com/restaurants/madison-todd-drive/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=18084568136246062602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "43.0360258",
      "poi_longitude": "-89.4150607",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 608-274-1221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-89df-736f-a79b-7d1ccf281a93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-89df-736f-a79b-7d1ccf281a93",
        "storage_key": "property/6767906449167127/019d0215-89df-736f-a79b-7d1ccf281a93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHccCSrQgB4gRCm5LXedK-fo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_80f1df5a-d83e-436a-806b-06a1f03c76ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "The Great Dane Pub & Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "123 E Doty St, Madison, WI 53703, USA",
      "poi_short_description": "A changing roster of craft brews & pub eats served in a lively venue with beer garden & pool tables.",
      "poi_long_description": "People say this brewpub offers delicious food and a wide selection of interesting beers. They also highlight the fun atmosphere, friendly and helpful service, and quirky menu names.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.greatdanepub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11167156264934311946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-great-dane-pub--brewing-company",
      "poi_latitude": "43.074447",
      "poi_longitude": "-89.380175",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 608-284-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-89e1-704a-872c-36bfe88df239.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-89e1-704a-872c-36bfe88df239",
        "storage_key": "property/6767906449167127/019d0215-89e1-704a-872c-36bfe88df239.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-uC2z9TBogRCgiw8nS1-Zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_cb3e3c8f-a6ec-4174-9c33-1d74e65cc901",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Café Hollander Hilldale",
      "poi_type": "Restaurants",
      "poi_address": "701 Hilldale Wy, Madison, WI 53705, USA",
      "poi_short_description": "Belgian beers & comfort-food fare served in a European-style cafe with a vintage-chic vibe.",
      "poi_long_description": "People say this restaurant offers a wide variety of food options, including burgers, mussels, and cheese curds, as well as a great beer selection and creative cocktails. They also highlight the friendly and attentive service, and the fun, upbeat atmosphere with indoor, outdoor, and rooftop seating.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cafehollander.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11326194114078951763&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "caf-hollander-hilldale",
      "poi_latitude": "43.0730069",
      "poi_longitude": "-89.4538088",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 608-237-3168",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-89df-736f-a79b-7d1ccf281a93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-89df-736f-a79b-7d1ccf281a93",
        "storage_key": "property/6767906449167127/019d0215-89df-736f-a79b-7d1ccf281a93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK8GfgSCsB4gRU8nLuom5Lp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_888adff0-88a2-4fc8-8f77-3ad0a1786c93",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1810 Monroe St, Madison, WI 53711, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique and interesting products, including fresh produce, ready-made meals, and seasonal items. They highlight the reasonable prices, good value, and fun shopping experience. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-a459-7585-8118-356c2438d4b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-a459-7585-8118-356c2438d4b9",
        "storage_key": "property/6767906449167127/019d0215-a459-7585-8118-356c2438d4b9.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/wi/madison/712/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4168082682443687732&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "43.0649866",
      "poi_longitude": "-89.4175436",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 608-257-1916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8da2-71fe-b3ed-95bb6df7cc71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8da2-71fe-b3ed-95bb6df7cc71",
        "storage_key": "property/6767906449167127/019d0215-8da2-71fe-b3ed-95bb6df7cc71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTR7ZN2sB4gRNGeDwR0B2Dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_477de4d3-3c43-4fd1-a822-90098f1a8b31",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Woodman's Food Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "725 S Gammon Rd, Madison, WI 53719, USA",
      "poi_short_description": "Chain of full-service supermarkets offering typical groceries, plus produce & liquor.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, groceries, and liquor, including international and organic options. They also highlight the affordable prices, clean aisles, and helpful staff.\n\nOther reviews mention the store can be overwhelming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-a45c-74bd-baf7-c4da7925f8b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-a45c-74bd-baf7-c4da7925f8b9",
        "storage_key": "property/6767906449167127/019d0215-a45c-74bd-baf7-c4da7925f8b9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.woodmans-food.com/madisonwest/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12648067730070058745&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodmans-food-market",
      "poi_latitude": "43.0487177",
      "poi_longitude": "-89.50078979999999",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 608-274-8944",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8da2-71fe-b3ed-95bb6df7cc71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8da2-71fe-b3ed-95bb6df7cc71",
        "storage_key": "property/6767906449167127/019d0215-8da2-71fe-b3ed-95bb6df7cc71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhZIGe1CuB4gR-TbokZb2hq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_56abe06d-a20e-4373-a9ca-6a752a961d5d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4710 Madison Yards Way, Madison, WI 53705, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh, organic, and specialty products, including produce, bakery items, and prepared foods. They also highlight the clean and well-organized store, convenient parking, and friendly staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-a5a5-756a-9598-062fe2618d2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-a5a5-756a-9598-062fe2618d2a",
        "storage_key": "property/6767906449167127/019d0215-a5a5-756a-9598-062fe2618d2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/madisonsegoe?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=8899181393492354590&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "43.0746759",
      "poi_longitude": "-89.457967",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 608-233-9566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8da2-71fe-b3ed-95bb6df7cc71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8da2-71fe-b3ed-95bb6df7cc71",
        "storage_key": "property/6767906449167127/019d0215-8da2-71fe-b3ed-95bb6df7cc71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7aIEF2sB4gRHqbg1lM-gHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9370ba44-8b27-486a-8080-6331bcdb32e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Hilldale Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "726 N Midvale Blvd, Madison, WI 53705, USA",
      "poi_short_description": "Sophisticated retail complex with a department store, high-end specialty shops, eateries & a cinema.",
      "poi_long_description": "People say this shopping center offers a great variety of shops and restaurants, with a clean and beautifully landscaped environment. They also highlight the walkable nature of the center, making it a great place to enjoy the outdoors.\n\nSome reviews mention the parking can be limited, especially during busy periods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-a46a-75bf-b871-3251363ed089.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-a46a-75bf-b871-3251363ed089",
        "storage_key": "property/6767906449167127/019d0215-a46a-75bf-b871-3251363ed089.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://hilldale.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6462075947680418620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilldale-shopping-center",
      "poi_latitude": "43.073325",
      "poi_longitude": "-89.453172",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 608-284-8162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8dc3-7241-8b7d-f14862be839c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8dc3-7241-8b7d-f14862be839c",
        "storage_key": "property/6767906449167127/019d0215-8dc3-7241-8b7d-f14862be839c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG-nB4kCsB4gRPEsWPdbnrVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c6dbb388-2888-490c-86ef-608c330b10cd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "4550 Verona Rd, Madison, WI 53711, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of products and tools, including lumber, electrical wire, and garden supplies. They also highlight the helpful and friendly staff, and the convenient curbside pickup service.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-a9af-76db-aae0-7c3c3e65d7eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-a9af-76db-aae0-7c3c3e65d7eb",
        "storage_key": "property/6767906449167127/019d0215-a9af-76db-aae0-7c3c3e65d7eb.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/West-Madison/WI/Madison/53711/4909?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5868304310845959370&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "43.0363524",
      "poi_longitude": "-89.457314",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 608-276-7922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8dc3-7241-8b7d-f14862be839c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8dc3-7241-8b7d-f14862be839c",
        "storage_key": "property/6767906449167127/019d0215-8dc3-7241-8b7d-f14862be839c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf0mG6-qtB4gRyuzd2a1ncFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_90c2c5a2-e455-4895-939a-e8c115debf9e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "University of Wisconsin–Madison",
      "poi_type": "Education",
      "poi_address": "500 Lincoln Dr, Madison, WI 53706, USA",
      "poi_short_description": "Lakefront research school offers 930+ acres of gardens & natural areas, including an arboretum.",
      "poi_long_description": "Lakefront research school offers 930+ acres of gardens & natural areas, including an arboretum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-7ff6-777a-9886-e22eddb03581.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-7ff6-777a-9886-e22eddb03581",
        "storage_key": "property/6767906449167127/019d0215-7ff6-777a-9886-e22eddb03581.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.wisc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14546738811594029668&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-wisconsinmadison",
      "poi_latitude": "43.07551429999999",
      "poi_longitude": "-89.4154526",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 608-263-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8f60-77df-8ded-0ff9ef15f3a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8f60-77df-8ded-0ff9ef15f3a5",
        "storage_key": "property/6767906449167127/019d0215-8f60-77df-8ded-0ff9ef15f3a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHUh_CpWsB4gRZDpzkeBl4Mk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fd7b09c8-c84c-4117-9610-81689fdf1091",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Union South",
      "poi_type": "Education",
      "poi_address": "1308 W Dayton St, Madison, WI 53715, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-ac43-714b-8654-836a4ed0eb93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-ac43-714b-8654-836a4ed0eb93",
        "storage_key": "property/6767906449167127/019d0215-ac43-714b-8654-836a4ed0eb93.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://union.wisc.edu/visit/union-south/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8005236616394776311&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "union-south",
      "poi_latitude": "43.0719999",
      "poi_longitude": "-89.40764639999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 608-890-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8f60-77df-8ded-0ff9ef15f3a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8f60-77df-8ded-0ff9ef15f3a5",
        "storage_key": "property/6767906449167127/019d0215-8f60-77df-8ded-0ff9ef15f3a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJteRWAsasB4gR9x4p_0lQGG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4394bd31-508e-485c-a4da-8471eca7e1ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "College Library",
      "poi_type": "Education",
      "poi_address": "600 N Park St, Madison, WI 53706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-ae08-702f-8654-46d4b67ef5cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-ae08-702f-8654-46d4b67ef5cc",
        "storage_key": "property/6767906449167127/019d0215-ae08-702f-8654-46d4b67ef5cc.webp",
        "width": 1024,
        "height": 580
      },
      "poi_business_url": "https://www.library.wisc.edu/college/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14230171379032079492&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "college-library",
      "poi_latitude": "43.076757",
      "poi_longitude": "-89.40125599999999",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 608-262-3245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-9781-7434-a9c2-95f53b7df0d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-9781-7434-a9c2-95f53b7df0d8",
        "storage_key": "property/6767906449167127/019d0215-9781-7434-a9c2-95f53b7df0d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq0BshbWsB4gRhDwjfHm5e8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_2c6ad35b-3218-4db2-9651-dddb586cb75c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Edgewood University",
      "poi_type": "Education",
      "poi_address": "1000 Edgewood College Dr, Madison, WI 53711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-4be1-77fe-8090-d068cf678e12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-4be1-77fe-8090-d068cf678e12",
        "storage_key": "property/6767906449167127/019d0215-4be1-77fe-8090-d068cf678e12.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.edgewood.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8817602143010084950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edgewood-university",
      "poi_latitude": "43.0574735",
      "poi_longitude": "-89.42166999999999",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-444-4861",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8f60-77df-8ded-0ff9ef15f3a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8f60-77df-8ded-0ff9ef15f3a5",
        "storage_key": "property/6767906449167127/019d0215-8f60-77df-8ded-0ff9ef15f3a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO67SheGsB4gRVtjWcG5qXno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1db87018-ee37-4352-b328-510a3921809d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Memorial Library",
      "poi_type": "Education",
      "poi_address": "728 State St, Madison, WI 53706, USA",
      "poi_short_description": "University library featuring a collection of scholarly works, plus study areas (some isolated).",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-b16f-72e2-ae9f-1855e58b3aa6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-b16f-72e2-ae9f-1855e58b3aa6",
        "storage_key": "property/6767906449167127/019d0215-b16f-72e2-ae9f-1855e58b3aa6.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://www.library.wisc.edu/memorial/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16789845164141707667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-library",
      "poi_latitude": "43.075434",
      "poi_longitude": "-89.39786699999999",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 608-262-3343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-9781-7434-a9c2-95f53b7df0d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-9781-7434-a9c2-95f53b7df0d8",
        "storage_key": "property/6767906449167127/019d0215-9781-7434-a9c2-95f53b7df0d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62GZSjVTBogRkwF6ajiDAek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_aa056e72-f4ab-4644-9f3b-5ab7ed97c187",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Camp Randall Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1440 Monroe St, Madison, WI 53711, USA",
      "poi_short_description": "Sports stadium hosting the University of Wisconsin Badgers football games & other large events.",
      "poi_long_description": "People say this stadium offers a fun game day environment and is a great place to watch sports, especially the Badgers. They highlight the fantastic atmosphere and the friendly, welcoming fans. They also like the helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-b2ca-76cb-9414-6f8af115e3f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-b2ca-76cb-9414-6f8af115e3f1",
        "storage_key": "property/6767906449167127/019d0215-b2ca-76cb-9414-6f8af115e3f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uwbadgers.com/sports/2015/08/21/GEN_2014010132.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1008910671302549578&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "camp-randall-stadium",
      "poi_latitude": "43.0699446",
      "poi_longitude": "-89.4126871",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 608-262-1866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-d620-7608-a35e-c9931cca48f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d620-7608-a35e-c9931cca48f8",
        "storage_key": "property/6767906449167127/019d0215-d620-7608-a35e-c9931cca48f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP1HVdcSsB4gRSuAW_eheAA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_583aa47a-eb47-4010-85a4-f82019e9ffed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Henry Vilas Zoo",
      "poi_type": "Entertainment",
      "poi_address": "702 S Randall Ave, Madison, WI 53715, USA",
      "poi_short_description": "Offering free entry, this zoo features animals from around the world, plus gifts, food & treats.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including lions, tigers, bears, and orangutans, and that the exhibits are well-maintained and clean. They highlight the free admission and parking, and the family-friendly atmosphere with play areas and picnic spots. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-b302-74d2-8a7d-5285f465770d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-b302-74d2-8a7d-5285f465770d",
        "storage_key": "property/6767906449167127/019d0215-b302-74d2-8a7d-5285f465770d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.henryvilaszoo.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10628532423613094977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "henry-vilas-zoo",
      "poi_latitude": "43.06061039999999",
      "poi_longitude": "-89.410035",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 608-266-4732",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk_BDgLmtB4gRQRwuSe0hgJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_94c3f411-8f36-4528-a0e6-855ab75be697",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Kohl Center",
      "poi_type": "Entertainment",
      "poi_address": "601 W Dayton St, Madison, WI 53703, USA",
      "poi_short_description": "Modern, on-campus sports facility for Badgers collegiate basketball & hockey games.",
      "poi_long_description": "People say this arena offers a variety of sporting events, including hockey and basketball games, as well as concerts and graduations. They highlight the clean facilities, comfortable seating, and good sightlines from any seat. They also like the friendly and helpful staff, and the easy access to concessions.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.uwbadgers.com/sports/2015/08/21/GEN_2014010135.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12797798035405878347&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kohl-center",
      "poi_latitude": "43.0694893",
      "poi_longitude": "-89.3969716",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 608-263-5645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS-YVBTNTBogRSzSP74HpmrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_0769e8a1-fc81-4916-8ea6-f78f2a8e8dbb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Madison Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "100 N Hamilton St, Madison, WI 53703, USA",
      "poi_short_description": "3 floors of interactive & educational exhibits designed for kids 12 & under plus a cafe.",
      "poi_long_description": "People say this children's museum offers a wide variety of engaging and interactive exhibits, including indoor and outdoor play areas, a rooftop garden, and an art studio. They highlight the affordable ticket prices, discounts, and free admission on Thursday evenings, as well as the clean and well-maintained facilities. They also like the friendly and helpful staff who interact positively with children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-508e-740b-9230-6322f73ee19c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-508e-740b-9230-6322f73ee19c",
        "storage_key": "property/6767906449167127/019d0215-508e-740b-9230-6322f73ee19c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://madisonchildrensmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9939938927957093187&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "madison-childrens-museum",
      "poi_latitude": "43.0769396",
      "poi_longitude": "-89.3843946",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 608-256-6445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-9286-77b6-a668-5ee2a9c50655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-9286-77b6-a668-5ee2a9c50655",
        "storage_key": "property/6767906449167127/019d0215-9286-77b6-a668-5ee2a9c50655.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJf0C9UkdTBogRQ6v1ecrB8Yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_560c6fb1-cf0e-4d5f-8467-636bc005da4f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Breese Stevens Field",
      "poi_type": "Entertainment",
      "poi_address": "917 E Mifflin St, Madison, WI 53703, USA",
      "poi_short_description": "Expansive sports field & stadium used for high school soccer games & tournaments.",
      "poi_long_description": "People say this stadium offers a variety of events, including concerts, soccer games, and ultimate frisbee matches. They highlight the spacious layout, easy access, and great views from most seats. They also like the friendly staff and the fun, welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-b6e0-743f-9b11-d58dfa123e89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-b6e0-743f-9b11-d58dfa123e89",
        "storage_key": "property/6767906449167127/019d0215-b6e0-743f-9b11-d58dfa123e89.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.breesestevensfield.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18171166222194452704&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "breese-stevens-field",
      "poi_latitude": "43.0833459",
      "poi_longitude": "-89.3730576",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 608-622-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-d620-7608-a35e-c9931cca48f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d620-7608-a35e-c9931cca48f8",
        "storage_key": "property/6767906449167127/019d0215-d620-7608-a35e-c9931cca48f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG5WaHW9TBogR4Ch6dGfzLPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_65c8338d-88e1-4c5c-8ebf-263af5cdfa55",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Madison Veterinary Specialists & Emergency Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2704 Royal Ave, Madison, WI 53713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.mvsvets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2380248186565436348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "madison-veterinary-specialists--emergency-care",
      "poi_latitude": "43.0431788",
      "poi_longitude": "-89.3570917",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 608-274-7772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCyp1jsOvB4gRvCOAVR1XCCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_3e76bbb2-3e66-40d2-8a16-84a702067758",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "UW Veterinary Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2015 Linden Dr, Madison, WI 53706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-b91d-759a-994f-723b5ae7482a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-b91d-759a-994f-723b5ae7482a",
        "storage_key": "property/6767906449167127/019d0215-b91d-759a-994f-723b5ae7482a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://uwveterinarycare.wisc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3829538167726453384&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uw-veterinary-care",
      "poi_latitude": "43.07527779999999",
      "poi_longitude": "-89.42111109999999",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 608-263-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9clkQeusB4gRiLIifaxAJTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_dac5ee9e-4099-4d36-9100-6cbeceb05091",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2311 W Broadway, Monona, WI 53713, USA",
      "poi_short_description": "Spacious gym offering cardio equipment, tanning beds, massage chairs, showers and more.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines, and the facility is clean and spacious. They highlight the affordable prices, 24/7 access, and positive, non-intimidating atmosphere. They also like the friendly, helpful, and supportive staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.planetfitness.com/gyms/madison-west-broadway-wi?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9244086837037815976&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "43.0447752",
      "poi_longitude": "-89.350579",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 608-223-9075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhR6TLUVSBogRqNiAQgCYSYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a8b799a4-40db-45c6-bb01-30eb77fec5e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "School Of Veterinary Medicine",
      "poi_type": "Health and Wellness",
      "poi_address": "Veterinary Medicine Bldg, 2015 Linden Dr, Madison, WI 53706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.vetmed.wisc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16638721941671365540&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "school-of-veterinary-medicine",
      "poi_latitude": "43.0753843",
      "poi_longitude": "-89.4203653",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 608-263-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ542Ax-ysB4gRpMvRQXOd6OY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_484d7b6d-2d35-402a-a17a-f36f0431b27c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Bliss Nail Bar",
      "poi_type": "Health and Wellness",
      "poi_address": "2701 Monroe St # 240, Madison, WI 53711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-ba60-73dc-878b-1d5a1cbc7dc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-ba60-73dc-878b-1d5a1cbc7dc5",
        "storage_key": "property/6767906449167127/019d0215-ba60-73dc-878b-1d5a1cbc7dc5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://blissnailbarmadisonwi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13304896074119390450&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bliss-nail-bar",
      "poi_latitude": "43.0566082",
      "poi_longitude": "-89.42908630000001",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 608-733-7379",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA5SyLv2tB4gR8iRgr3x8pLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_c62721ca-5400-4cfb-ae82-8b9793fa9203",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "[solidcore] Madison",
      "poi_type": "Health and Wellness",
      "poi_address": "536 N Midvale Blvd, Madison, WI 53705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-b982-7262-a78a-3490840bfb72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-b982-7262-a78a-3490840bfb72",
        "storage_key": "property/6767906449167127/019d0215-b982-7262-a78a-3490840bfb72.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.solidcore.co/wi/wisconsin/madison/?utm_source=google&utm_medium=search&utm_content=local-listing&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15680559032422687995&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "solidcore-madison",
      "poi_latitude": "43.0715095",
      "poi_longitude": "-89.4523036",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 608-216-2244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg1ZmuTCtB4gR--QYX1yJnNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8afc1403-824e-4308-8e4a-ae73af1d2539",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Madison Nail Lounge",
      "poi_type": "Health and Wellness",
      "poi_address": "795 University Ave, Madison, WI 53715, USA",
      "poi_short_description": "Nail salon, manicurists, and pedicurists providing full sets and gel manicures, among other services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-be19-72fb-bf8e-a2b7cec5d759.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-be19-72fb-bf8e-a2b7cec5d759",
        "storage_key": "property/6767906449167127/019d0215-be19-72fb-bf8e-a2b7cec5d759.webp",
        "width": 1280,
        "height": 1243
      },
      "poi_business_url": "http://madisonnaillounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6737438417130240198&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "madison-nail-lounge",
      "poi_latitude": "43.0730802",
      "poi_longitude": "-89.3986882",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 608-720-1011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFQpdWn-tB4gRxjgePYswgF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_00639bd8-68cc-48d9-97cd-73ed180ced65",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "2860 University Ave, Madison, WI 53705, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-beb9-76d9-a122-271d14285fcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-beb9-76d9-a122-271d14285fcd",
        "storage_key": "property/6767906449167127/019d0215-beb9-76d9-a122-271d14285fcd.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/wi/madison/2860-university-avenue?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5904768693616925163&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "43.0754338",
      "poi_longitude": "-89.4381509",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 608-233-7067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn1P41YNvYogR61nij9fz8VE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_8343fc92-d8e3-4eef-9ee3-cf41555095a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Aetheria Hair Salon and Wig Boutique",
      "poi_type": "Health and Wellness",
      "poi_address": "845 E Johnson St, Madison, WI 53703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-c12f-72b5-a122-524de96b84a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-c12f-72b5-a122-524de96b84a7",
        "storage_key": "property/6767906449167127/019d0215-c12f-72b5-a122-524de96b84a7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://aetheriahair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18159795437209553428&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aetheria-hair-salon-and-wig-boutique",
      "poi_latitude": "43.0840425",
      "poi_longitude": "-89.37645599999999",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 608-530-1698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf_o1YLhTBogRFIqiRLyNBPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_90509640-0acd-4942-bd8f-aa4fe6438841",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "UW Health University Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "600 Highland Ave, Madison, WI 53792, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-7e96-77ca-9ebe-aa677b8484a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-7e96-77ca-9ebe-aa677b8484a1",
        "storage_key": "property/6767906449167127/019d0215-7e96-77ca-9ebe-aa677b8484a1.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.uwhealth.org/locations/university-hospital-170",
      "poi_directions_map_url": "https://maps.google.com/?cid=7762034646663703722&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uw-health-university-hospital",
      "poi_latitude": "43.0768809",
      "poi_longitude": "-89.4319299",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 608-263-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-9283-741f-b911-ae20c856e47c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-9283-741f-b911-ae20c856e47c",
        "storage_key": "property/6767906449167127/019d0215-9283-741f-b911-ae20c856e47c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJeae7SfKsB4gRqiyq2GJJuGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7519fda9-33d4-4767-8aae-d97391a1f798",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "SSM Health St. Mary's Hospital - Madison",
      "poi_type": "Health and Wellness",
      "poi_address": "700 S Brooks St, Madison, WI 53715, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-5132-71aa-82fd-b32be097dd46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-5132-71aa-82fd-b32be097dd46",
        "storage_key": "property/6767906449167127/019d0215-5132-71aa-82fd-b32be097dd46.webp",
        "width": 1143,
        "height": 874
      },
      "poi_business_url": "https://www.ssmhealth.com/locations/st-marys-hospital-madison?utm_id=sys-listings-1&linksource=sys_listing_links-gmb_listing&y_source=1_MjMyNTc3NTgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4422916005645905861&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ssm-health-st-marys-hospital---madison",
      "poi_latitude": "43.0593048",
      "poi_longitude": "-89.4030523",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 608-251-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-9283-741f-b911-ae20c856e47c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-9283-741f-b911-ae20c856e47c",
        "storage_key": "property/6767906449167127/019d0215-9283-741f-b911-ae20c856e47c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJp7GIaNasB4gRxe_pa6xaYT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1e20be98-70cc-453b-bbf0-49d51eedce3a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "James Madison Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "614 E Gorham St, Madison, WI 53703, USA",
      "poi_short_description": "An urban space along the lake, with grassy areas, sports courts, athletic fields & a playground.",
      "poi_long_description": "People say this park offers a beach, lake, picnic areas, restrooms, and walking trails. They highlight the beautiful lake views, the nice breeze, and the variety of activities, including a playground, basketball courts, and volleyball court. They also like the safe and family-friendly atmosphere, and the well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-c46c-77ba-8835-52719863300e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-c46c-77ba-8835-52719863300e",
        "storage_key": "property/6767906449167127/019d0215-c46c-77ba-8835-52719863300e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cityofmadison.com/parks/find-a-park/park.cfm?id=1241",
      "poi_directions_map_url": "https://maps.google.com/?cid=16168677138266404854&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "james-madison-park",
      "poi_latitude": "43.0813926",
      "poi_longitude": "-89.3828841",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 608-266-4711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-9285-77ae-958f-4eb342e3570e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-9285-77ae-958f-4eb342e3570e",
        "storage_key": "property/6767906449167127/019d0215-9285-77ae-958f-4eb342e3570e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4xi40NTBogR9jdZIjGuYuA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_54061236-10de-4ee9-bf94-8537ebea4176",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "University of Wisconsin–Madison Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1207 Seminole Hwy, Madison, WI 53711, USA",
      "poi_short_description": "1,200 acres of varied habitats including prairies, forests & wetlands plus trails & nature classes.",
      "poi_long_description": "Visitors say this arboretum offers a lovely place to take a walk and enjoy the natural beauty of the area, with opportunities to see a wide variety of plant and wildlife. They also highlight the beautiful views of the sunset over Lake Wingra.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-c3c8-7293-827d-0989f364d6c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-c3c8-7293-827d-0989f364d6c7",
        "storage_key": "property/6767906449167127/019d0215-c3c8-7293-827d-0989f364d6c7.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://arboretum.wisc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4817247072601894084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-wisconsinmadison-arboretum",
      "poi_latitude": "43.0428709",
      "poi_longitude": "-89.4243205",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8ieExKtB4gRxOy5jbBM2kI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_cecf8d54-f023-4f49-a445-2907a2924ec6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Tenney Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "402 N Thornton Ave, Madison, WI 53703, USA",
      "poi_short_description": "This 37-acre lakeside park features a playground, a boat launch,  tennis/pickleball courts & more.",
      "poi_long_description": "People say this park offers a long pier, a swimming beach, and trails for walking, running, and fishing. They highlight the beautiful views of the lake, the peaceful atmosphere, and the variety of activities available, including boating, kayaking, and sports. They also like the well-maintained trails, the ample parking, and the availability of benches and shaded spots for relaxation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-c5a2-73df-a46d-f02e59c4de88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-c5a2-73df-a46d-f02e59c4de88",
        "storage_key": "property/6767906449167127/019d0215-c5a2-73df-a46d-f02e59c4de88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmadison.com/parks/find-a-park/park.cfm?id=1357",
      "poi_directions_map_url": "https://maps.google.com/?cid=8737370584904932256&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tenney-park",
      "poi_latitude": "43.09204070000001",
      "poi_longitude": "-89.3671462",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 608-266-4711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-9285-77ae-958f-4eb342e3570e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-9285-77ae-958f-4eb342e3570e",
        "storage_key": "property/6767906449167127/019d0215-9285-77ae-958f-4eb342e3570e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4S4bKH1TBogRoJs0IEFgQXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_997e0d35-2140-44e3-9062-c735db141f42",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Elver Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1250 McKenna Blvd, Madison, WI 53719, USA",
      "poi_short_description": "227-acre area featuring sports fields & rinks, a seasonal splash park, playground & sledding hill.",
      "poi_long_description": "People say this park offers a variety of amenities, including walking paths, a playground, a splash pad, sports fields, and a disc golf course. They highlight the peaceful and scenic atmosphere, and the well-maintained facilities. They also like the ample parking and restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-c91b-70d1-810f-5e26f746a02b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-c91b-70d1-810f-5e26f746a02b",
        "storage_key": "property/6767906449167127/019d0215-c91b-70d1-810f-5e26f746a02b.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.cityofmadison.com/parks/find-a-park/park.cfm?id=1172",
      "poi_directions_map_url": "https://maps.google.com/?cid=18390592916668781845&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elver-park",
      "poi_latitude": "43.0354566",
      "poi_longitude": "-89.50081159999999",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 608-266-4711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-9285-77ae-958f-4eb342e3570e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-9285-77ae-958f-4eb342e3570e",
        "storage_key": "property/6767906449167127/019d0215-9285-77ae-958f-4eb342e3570e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJacfxLDauB4gRFZXb9tGCOP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d02c7a79-ad1b-40e4-92e8-b3b0ed2e8cde",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "McKee Farms Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2930 Chapel Valley Rd, Fitchburg, WI 53711, USA",
      "poi_short_description": "This sizable park features many sport fields & courts, plus a large pond, playground & pathways.",
      "poi_long_description": "People say this park offers a playground, splash pad, walking path, and tennis courts. They highlight the park is clean, accessible, and fun for all ages. They also like the ample parking and green space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-6008-730d-b8a1-2e68c6f38ce6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-6008-730d-b8a1-2e68c6f38ce6",
        "storage_key": "property/6767906449167127/019d0215-6008-730d-b8a1-2e68c6f38ce6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.fitchburgwi.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3902528563480713419&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mckee-farms-park",
      "poi_latitude": "43.0138822",
      "poi_longitude": "-89.4316506",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 608-270-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-9285-77ae-958f-4eb342e3570e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-9285-77ae-958f-4eb342e3570e",
        "storage_key": "property/6767906449167127/019d0215-9285-77ae-958f-4eb342e3570e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf0YMY4ayB4gRy1gVUA2RKDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0b7d1bb3-2459-4f64-947f-b66ac1a143b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "WPS Health Solutions",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1717 W Broadway, Monona, WI 53713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-cab8-7462-b97f-e60a89a45591.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-cab8-7462-b97f-e60a89a45591",
        "storage_key": "property/6767906449167127/019d0215-cab8-7462-b97f-e60a89a45591.webp",
        "width": 986,
        "height": 632
      },
      "poi_business_url": "https://www.wpshealthsolutions.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=533262986880032550&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wps-health-solutions",
      "poi_latitude": "43.045578",
      "poi_longitude": "-89.3443679",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 608-977-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjwmXfkhSBogRJh_ZeNyHZgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6aeb3553-1df7-4216-862c-28256f4c8176",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "RockAuto, LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6418 Normandy Ln #100, Madison, WI 53719, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-cb31-74cf-a189-a7065a14e9a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-cb31-74cf-a189-a7065a14e9a8",
        "storage_key": "property/6767906449167127/019d0215-cb31-74cf-a189-a7065a14e9a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rockauto.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=176370742643737081&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rockauto-llc",
      "poi_latitude": "43.0567814",
      "poi_longitude": "-89.4902685",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 608-661-1376",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0ZFxdF-uB4gR-UENiEGYcgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7870af1c-bcbc-4863-b422-ded6dec09fb4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "The Spark",
      "poi_type": "Major Employers & Offices",
      "poi_address": "821 E Washington Ave, Madison, WI 53703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-cb61-7439-a619-d374bcc66fea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-cb61-7439-a619-d374bcc66fea",
        "storage_key": "property/6767906449167127/019d0215-cb61-7439-a619-d374bcc66fea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amfam.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9720118118374785779&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-spark",
      "poi_latitude": "43.081245",
      "poi_longitude": "-89.37405299999999",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 608-242-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_047pG5TBogR80KR5O3L5IY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4f06c079-d7d4-4d9b-8c09-ec17f32d9b50",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Sub-Zero Group, Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2835 Bud's Dr, Fitchburg, WI 53719, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-ce8c-73cd-abae-32692b00fd4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-ce8c-73cd-abae-32692b00fd4a",
        "storage_key": "property/6767906449167127/019d0215-ce8c-73cd-abae-32692b00fd4a.webp",
        "width": 1280,
        "height": 641
      },
      "poi_business_url": "https://www.subzero-wolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042112130604267321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sub-zero-group-inc",
      "poi_latitude": "43.0087944",
      "poi_longitude": "-89.4667687",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 608-271-2233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wYwBOqtB4gROfciDaybumE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_808bb570-3611-4fae-903d-8fc8f94760ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "custom",
      "poi_name": "Vita Plus - Madison Distribution Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3019 Progress Rd, Madison, WI 53716, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-cffd-758e-8175-39e4bee37d24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-cffd-758e-8175-39e4bee37d24",
        "storage_key": "property/6767906449167127/019d0215-cffd-758e-8175-39e4bee37d24.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.vitaplus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2738892699428786647&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vita-plus---madison-distribution-center",
      "poi_latitude": "43.0545895",
      "poi_longitude": "-89.30255989999999",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 608-226-3320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-8a24-748f-9e0c-bea4fb7de872",
        "storage_key": "property/6767906449167127/019d0215-8a24-748f-9e0c-bea4fb7de872.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBTmFOKBRBogR1xFdG2aAAiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_e5cab0825043ce4ff053fb37",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_be416bd80f21881ffa050eb0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_3e6c8884f958907687316510",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_28b4e56a665becee17486e74",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_caab4e4931f4ed9f611c60c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_d3575bcf-bb25-4fa8-81a6-8163d0a247b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "rating": "5.0",
      "name": "frita frees",
      "text": "I ended up being stuck with my other lease so I could not move forward with leasing here as I planned, but Nick was extremely responsive and very helpful and transparent in answering all my questions about the apartment and leasing process. I wish my apartment's leasing office was as helpful as he is !!!",
      "date": "2025-12-29",
      "title": ""
    },
    {
      "id": "custom_d9eb3666-c48c-46a2-abfb-89107b92778f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "rating": "5.0",
      "name": "Keri Disch",
      "text": "We will be going on our 5th year here at Swan Creek. Being next to two parks and a bike path makes it a perfect spot for us. Nick, our Community Director is amazing. He goes above and beyond for us residents and is a genuinely caring, friendly person. The maintenance department is always fast with their service and helpful when you have a problem, question or something that needs changing. Ilir has been here a while, he's great at what he does, is very knowledgeable and courteous. If you're looking for a place to call home, please check out Swan Creek!",
      "date": "2025-05-09",
      "title": ""
    },
    {
      "id": "custom_b46e5181-b983-49bc-8dcf-5f28c6df633a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "rating": "5.0",
      "name": "Irene hernandez",
      "text": "Great location with many trails. Perfect neighborhood if you're a dog owner or enjoying walking. The property itself is clean and well taken care of. Nick has done an amazing job as the Community Director. He is always making sure if we have any questions or concerns that they are taken care of and answered. He has gone above and beyond in trying to make changes throughout the property. Any repairs that are ever needed have always been taken care of immediately. Management has been so helpful during our time here.",
      "date": "2024-06-24",
      "title": ""
    },
    {
      "id": "custom_14e26d93-441c-49b2-a2ba-79ee4943239f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "rating": "5.0",
      "name": "Madeline Brown",
      "text": "I am very happy I made the decision to move into swan creek apartments when I relocated to the Madison area. Kara is an exceptional director. Her customer service is what sold me on signing a lease - She really shows that she cares about the residents who live here. The buildings are super quiet even with many dogs living on the property! My 3rd floor balcony is very spacious and the building is located close to parks and trails. The management team has communicated promptly and have been available to answer any questions or address any concerns.\nDennis who is in charge of maintenance is pleasant, professional, and gets things taken care of swiftly upon request.\nLiving at this property has made moving to a brand new city much more comforting.",
      "date": "2022-08-31",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_efccb1e9ed1bea3c96f609f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0216-1cda-7729-8a8f-e20b30d165e2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen area with furniture and bar stools.",
        "public_id": "019d0216-1cda-7729-8a8f-e20b30d165e2",
        "storage_key": "property/6767906449167127/019d0216-1cda-7729-8a8f-e20b30d165e2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FDhdUEUedFy"
    },
    {
      "id": "ec_fcb1efa362fe15643a47297f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0216-1c23-71ee-96c6-7ab9ff74a8e4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "View from a balcony overlooking a snowy apartment complex with multiple buildings and a blue sky.",
        "public_id": "019d0216-1c23-71ee-96c6-7ab9ff74a8e4",
        "storage_key": "property/6767906449167127/019d0216-1c23-71ee-96c6-7ab9ff74a8e4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Balcony",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=o2Mhv3USd29"
    },
    {
      "id": "ec_258428c823a2af53ef36a712",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0216-1c09-7258-ab28-29f4232d4165.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Treadmills and elliptical machines in a well-lit fitness center.",
        "public_id": "019d0216-1c09-7258-ab28-29f4232d4165",
        "storage_key": "property/6767906449167127/019d0216-1c09-7258-ab28-29f4232d4165.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ZpKnJaDDywT"
    },
    {
      "id": "ec_d02ce86ab339a840c3a2812b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0216-1c46-7049-9810-99aecc252760.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior of a well-equipped fitness center with treadmills, elliptical machines, and weight training equipment.",
        "public_id": "019d0216-1c46-7049-9810-99aecc252760",
        "storage_key": "property/6767906449167127/019d0216-1c46-7049-9810-99aecc252760.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Amenities - Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=9omJwZLfKS1"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e23be-98a3-76bf-9556-7250aed68256",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Swan Creek Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127"
    },
    {
      "lead_collector_id": "019e23be-992e-77a9-ad7c-2a8ec9e231e9",
      "lead_source": "LANDING_PAGE",
      "name": "Swan Creek Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-fitchburg-wi",
      "search_query": "apartments with in-unit laundry in Fitchburg WI",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Fitchburg",
      "h2_subtitle": "Discover the convenience of in-unit laundry in Fitchburg, WI. Enjoy the ease of having a full-size washer and dryer at Swan Creek.",
      "page_copy": "Swan Creek Apartments in Fitchburg, WI, offer the perfect blend of comfort and convenience with amenities like in-unit laundry. Imagine the ease of having a full-size washer and dryer right in your apartment, saving you time and allowing you to focus on what truly matters. Nestled in the serene Swan Creek neighborhood, these apartments provide a residential haven with the luxury of modern living.\n\nIn addition to the in-unit laundry facilities, residents at Swan Creek enjoy a plethora of other comforts. Ample storage options, including additional storage space and linen closets, cater to all your organizational needs. The community is situated in Dane County, providing easy access to shops, dining, and entertainment options. Experience top-notch living at Swan Creek, where convenience meets tranquility in Fitchburg.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
      "featured_image_media": {
        "alt_text": "Entrance gate to the Von Echra community pool area with fall foliage.",
        "public_id": "019d0215-0fcb-7059-8ebe-bcf476ffe3e2",
        "storage_key": "property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
        "width": 1930,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Fitchburg, WI",
      "seo_description": "Explore Swan Creek Apartments in Fitchburg, WI, featuring in-unit laundry and ample storage for convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-swan-creek",
      "search_query": "air conditioned apartments near Swan Creek neighborhood",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near Swan Creek",
      "h2_subtitle": "Stay comfortable with air conditioned living near Swan Creek. Discover the perfect climate-controlled retreat today.",
      "page_copy": "Located in the tranquil Swan Creek neighborhood, our apartment community offers the perfect air-conditioned haven. Enjoy modern living comforts with climate-controlled environments that provide relief during every season in Fitchburg, WI. At Swan Creek Apartments, maintain the ideal indoor temperature, enhancing your living experience in every way.\n\nOur residents benefit from a wide array of amenities beyond air conditioning, including full-size washers and dryers, ample storage solutions with additional storage spaces and linen closets, and much more. Conveniently situated in Dane County, Swan Creek Apartments offers easy access to local attractions, making it the ideal residential choice for those seeking comfort and convenience in one. Relax and thrive in a climate-friendly home at Swan Creek Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
      "featured_image_media": {
        "alt_text": "Entrance gate to the Von Echra community pool area with fall foliage.",
        "public_id": "019d0215-0fcb-7059-8ebe-bcf476ffe3e2",
        "storage_key": "property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
        "width": 1930,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near Swan Creek",
      "seo_description": "Find air conditioned apartments near Swan Creek neighborhood in Fitchburg, WI. Enjoy climate-controlled comfort and convenience at Swan Creek.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "generator",
      "page_item_url": "apartments-with-dishwashers-dane-county",
      "search_query": "apartments with dishwashers in Dane County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwashers in Dane County",
      "h2_subtitle": "Explore apartments equipped with dishwashers in Dane County. Experience hassle-free living at Swan Creek, Fitchburg, WI.",
      "page_copy": "Discover Swan Creek Apartments in Dane County, where modern convenience meets exceptional living. Each apartment comes equipped with a dishwasher, streamlining your daily routine and allowing more time for leisure. Located in the serene Swan Creek neighborhood of Fitchburg, WI, these apartments offer a blend of comfort and practicality.\n\nBeyond dishwashers, Swan Creek provides an array of features including in-unit laundry with full-size washers and dryers, spacious storage options, and linen closets. Residents enjoy access to local attractions and services, enhancing their lifestyle in this sought-after Dane County community. Make Swan Creek your home and enjoy the convenience of a well-appointed apartment designed with you in mind.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
      "featured_image_media": {
        "alt_text": "Entrance gate to the Von Echra community pool area with fall foliage.",
        "public_id": "019d0215-0fcb-7059-8ebe-bcf476ffe3e2",
        "storage_key": "property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
        "width": 1930,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwashers in Dane County",
      "seo_description": "Find apartments with dishwashers in Dane County. Discover convenience and comfort at Swan Creek Apartments in Fitchburg, WI.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-fitchburg-wi",
      "search_query": "dog-friendly apartments in Fitchburg WI",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Fitchburg, WI",
      "h2_subtitle": "Live happily with your furry friend in Fitchburg, WI. Discover dog-friendly living at Swan Creek Apartments.",
      "page_copy": "Swan Creek Apartments in Fitchburg, WI, are the perfect choice for pet lovers seeking a dog-friendly environment. Nestled in the peaceful Swan Creek neighborhood, these apartments welcome your furry companions, offering a community that truly caters to all its residents.\n\nIn addition to being pet-welcoming, Swan Creek boasts a range of amenities that elevate your living experience. Enjoy the convenience of storage solutions, full-size washers and dryers, and linen closets. The community's ideal location in Dane County makes it easy to access dog-friendly parks and services, ensuring your pet enjoys the best of Fitchburg along with you. Choose Swan Creek Apartments for a harmonious lifestyle tailor-made for you and your pet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
      "featured_image_media": {
        "alt_text": "Entrance gate to the Von Echra community pool area with fall foliage.",
        "public_id": "019d0215-0fcb-7059-8ebe-bcf476ffe3e2",
        "storage_key": "property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
        "width": 1930,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Fitchburg, WI",
      "seo_description": "Discover dog-friendly apartments in Fitchburg, WI, at Swan Creek. Enjoy living in a pet-welcoming community with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "generator",
      "page_item_url": "fitchburg-wi-apartments-with-fitness-center",
      "search_query": "Fitchburg WI apartments with fitness center",
      "category": "Amenity",
      "h1_title": "Fitchburg WI Apartments with Fitness Center",
      "h2_subtitle": "Stay active at our Fitchburg, WI apartments. Discover Swan Creek Apartments with an on-site fitness center today.",
      "page_copy": "Experience active living at Swan Creek Apartments in Fitchburg, WI, where our residents enjoy access to an on-site fitness center as part of a robust amenities package. Located in the serene Swan Creek neighborhood, you can maintain your fitness routine just steps from your front door, without needing a separate gym membership.\n\nOur community is designed for convenience and comfort, providing modern in-unit features like full-size washers and dryers, as well as ample storage options including additional storage spaces and linen closets. Situated in the heart of Dane County, our community also places you close to local parks and outdoor activities, further enhancing your lifestyle options. Choose Swan Creek Apartments and enjoy the perfect balance of fitness and home comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
      "featured_image_media": {
        "alt_text": "Entrance gate to the Von Echra community pool area with fall foliage.",
        "public_id": "019d0215-0fcb-7059-8ebe-bcf476ffe3e2",
        "storage_key": "property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
        "width": 1930,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitchburg WI Apartments with Fitness Center",
      "seo_description": "Find Fitchburg WI apartments with a fitness center at Swan Creek. Enjoy convenience and stay active in our well-equipped community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "generator",
      "page_item_url": "studio-apartments-fitchburg-wi",
      "search_query": "studio apartments Fitchburg WI",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Fitchburg, WI",
      "h2_subtitle": "Explore studio living in Fitchburg, WI. Discover the benefits of Swan Creek's efficient studio apartments today.",
      "page_copy": "Swan Creek Apartments offers stylish and efficient studio apartments in Fitchburg, WI, perfect for those seeking a compact living solution without sacrificing comfort. Located in the tranquil Swan Creek neighborhood, these studio spaces provide a practical home base accompanied by modern amenities.\n\nEach studio is thoughtfully designed to maximize space and functionality, featuring a full-size washer and dryer, ample storage solutions including linen closets, and additional storage spaces. Reside in a community that prioritizes convenience, with the ease of access to local shops and scenic Dane County attractions. Choose Swan Creek for a streamlined living experience in Fitchburg, WI, that supports your lifestyle with elegance and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
      "featured_image_media": {
        "alt_text": "Entrance gate to the Von Echra community pool area with fall foliage.",
        "public_id": "019d0215-0fcb-7059-8ebe-bcf476ffe3e2",
        "storage_key": "property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
        "width": 1930,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Fitchburg, WI",
      "seo_description": "Discover studio apartments in Fitchburg, WI, at Swan Creek. Enjoy efficient living with modern amenities and stylish designs in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-swan-creek",
      "search_query": "one bedroom apartments Swan Creek",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Swan Creek",
      "h2_subtitle": "Find your ideal one bedroom apartment in Swan Creek. Experience comfortable living in a serene setting at Swan Creek Apartments.",
      "page_copy": "Discover your new home in the one bedroom apartments at Swan Creek, a welcoming community in the heart of Fitchburg, WI. These thoughtfully designed apartments provide the perfect blend of comfort and convenience, offering a cozy retreat within the charming Swan Creek neighborhood.\n\nOur one bedroom apartments feature modern amenities, including full-size washers and dryers and ample storage options like linen closets and additional storage spaces. Situated in Dane County, Swan Creek Apartments allow for easy access to local attractions and daily necessities, making it an ideal location for anyone who values convenience. Embrace comfortable living in a tranquil environment with a one bedroom apartment at Swan Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
      "featured_image_media": {
        "alt_text": "Entrance gate to the Von Echra community pool area with fall foliage.",
        "public_id": "019d0215-0fcb-7059-8ebe-bcf476ffe3e2",
        "storage_key": "property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
        "width": 1930,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Swan Creek",
      "seo_description": "Explore one bedroom apartments in Swan Creek. Enjoy modern amenities and serene living in a convenient Fitchburg location at Swan Creek Apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167127",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-53711",
      "search_query": "two bedroom apartments near 53711",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 53711",
      "h2_subtitle": "Explore our two bedroom apartments near the 53711 area. Swan Creek Apartments offers comfort and convenience just around the corner.",
      "page_copy": "Discover spacious living with the two bedroom apartments at Swan Creek, conveniently located near the 53711 area code. Nestled in Fitchburg, WI, our community offers an ideal home base with easy access to local amenities and the wider Dane County region.\n\nOur two bedroom apartments provide ample living space, complemented by features such as full-size washers and dryers, additional storage spaces, and linen closets. Whether you are accommodating a growing family or need a dedicated home office, our well-designed layouts cater to your lifestyle needs. Enjoy the perfect blend of modern living and community charm at Swan Creek Apartments, right near the 53711 ZIP code.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
      "featured_image_media": {
        "alt_text": "Entrance gate to the Von Echra community pool area with fall foliage.",
        "public_id": "019d0215-0fcb-7059-8ebe-bcf476ffe3e2",
        "storage_key": "property/6767906449167127/019d0215-0fcb-7059-8ebe-bcf476ffe3e2.webp",
        "width": 1930,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 53711",
      "seo_description": "Find spacious two bedroom apartments near 53711 at Swan Creek Apartments. Enjoy modern amenities and a convenient Fitchburg location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11308811003"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6084674658"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KLG9G29R"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "fb62b79f-6dcb-4f8a-8f22-4b1a4db54fca"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/7da508a7-dde5-4372-b714-c7a6aaa1ce28/app.js?property=7da508a7-dde5-4372-b714-c7a6aaa1ce28&propertyName=Swan+Creek&channelUuid=c248e490-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47672016277"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik1HbFFDQkFyb0QxUDIrV0VJcXdzeGc9PSIsInZhbHVlIjoickY4bmRrbDdHRkxvUjNIU04yRk41Zz09IiwibWFjIjoiNGJkOGU4YjY0MjQ1Nzc1NWEyNTBkYTkyYjU5NTI5MDgxNGU2ODgzNGZiODc0MGExZGU4MjdlM2Q1OTM3YTU3YiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11308811003",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6084674658",
  "custom_google_gtm_id": "GTM-KLG9G29R",
  "custom_rollout_phase": "Phase 3",
  "custom_rentgrata_token": "fb62b79f-6dcb-4f8a-8f22-4b1a4db54fca",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/7da508a7-dde5-4372-b714-c7a6aaa1ce28/app.js?property=7da508a7-dde5-4372-b714-c7a6aaa1ce28&propertyName=Swan+Creek&channelUuid=c248e490-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47672016277",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik1HbFFDQkFyb0QxUDIrV0VJcXdzeGc9PSIsInZhbHVlIjoickY4bmRrbDdHRkxvUjNIU04yRk41Zz09IiwibWFjIjoiNGJkOGU4YjY0MjQ1Nzc1NWEyNTBkYTkyYjU5NTI5MDgxNGU2ODgzNGZiODc0MGExZGU4MjdlM2Q1OTM3YTU3YiJ9",
  "custom_audioeye_site_id": "4f492981-29c3-4b6c-93fb-27497f847a06",
  "custom_audioeye_site_hash": "3ee96708f26a16ae63f26de3b4cc0bb4"
};

export const generatedAt = '2026-10-27T17:12:00.821Z';
